import { apiUrls } from './index';
import { consts, USER_AUTH } from '../utils/consts';
import { http } from './fetch-wrapper';

let getProsController = new AbortController();
let requestSend = false;
export function getPros(searchTerm, sortBy, page, filter, authData) {
  if (requestSend) {
    requestSend = false;
    getProsController.abort();
    getProsController = new AbortController();
  }
  const headers = new Headers();
  headers.append('Authorization', authData);
  const currentPage = page - 1;
  requestSend = true;
  return http(
    `${apiUrls.SEARCH_USERS + searchTerm}&size=${consts.PAGE_SIZE}&page=${currentPage}&sort=${sortBy}&f=${filter}`,
    { method: 'GET', headers, signal: getProsController.signal },
  ).then((response) => {
    requestSend = false;
    return response;
  });
}

export function getUserDetails(userId, authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  const url = apiUrls.GET_V3_USER_DETAILS(userId);
  return http(url, { method: 'GET', headers });
}

export function getUserByRef(id) {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  const userAuth = localStorage.getItem(USER_AUTH);
  if (userAuth) {
    headers.append('Authorization', `Bearer ${userAuth}`);
  }
  return http(apiUrls.GET_USER_DETAILS_REF(id), { method: 'GET', headers });
}

export function getCallDetails(callId, authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  return http(`${apiUrls.CALLS}/${callId}`, { method: 'GET', headers });
}

export function addToShortlist(userId, authData, isForDelete) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  return http(apiUrls.ADD_TO_SHORTLIST(userId), { method: isForDelete ? 'DELETE' : 'POST', headers });
}

export function getProAvailabilityForTimezone(proId, timeZone, authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);

  return http(apiUrls.PRO_AVAILABILITY_V4(proId, timeZone), { method: 'GET', headers });
}



// WEBPACK FOOTER //
// ./api/pros.js